import clsx from "clsx";

import type { Confidence, ConfidenceWord as ConfidenceWordValue } from "../api/types";

interface ConfidenceWordProps {
  /** The word alone, or the whole value of a card (word, reason and what would make it Sure). */
  confidence: Confidence | ConfidenceWordValue;
  /** Show the reason and "would be Sure if" under the word. */
  showReason?: boolean;
  className?: string;
}

/**
 * Sure, Likely or Unsure. Confidence is not a state, so it takes no state colour: Unsure is told
 * apart by weight and by the mark in front of it.
 */
export function ConfidenceWord({ confidence, showReason = false, className }: ConfidenceWordProps) {
  const word = typeof confidence === "string" ? confidence : confidence.word;
  const reason = typeof confidence === "string" ? undefined : confidence.reason;
  const wouldBeSureIf = typeof confidence === "string" ? undefined : confidence.would_be_sure_if;
  return (
    <span className={clsx("confidence", className)} data-confidence={word} title={reason || undefined}>
      <span className="confidence__word">{word}</span>
      {showReason && reason && <span className="confidence__reason muted"> {reason}</span>}
      {showReason && wouldBeSureIf && <span className="confidence__reason muted"> Would be Sure if {wouldBeSureIf}.</span>}
    </span>
  );
}
